import Icon from "components/Icon/Icon";
import { srOnly } from "components/SrOnly";
import styled from "styled-components";
import { focusOutlineRule } from "styles/focus";

const PAYMENT_METHOD_GAP = "10px";

export const PaymentOptions = styled.fieldset`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${PAYMENT_METHOD_GAP};
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
`;

// Visually hidden, not display: none, so it stays focusable; the label after
// it draws the choice.
export const PaymentMethodInput = styled.input`
  ${srOnly}
`;

export const PaymentMethodLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 14px;
  width: fit-content;
  cursor: pointer;
  user-select: none;

  ${PaymentMethodInput}:focus-visible + & {
    ${focusOutlineRule}
  }
`;

export const PaymentMethodRadio = styled(Icon)<{ $selected: boolean }>`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.primaryAccent : theme.lightgrey};
`;

export const PaymentMethodTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  color: ${({ theme }) => theme.black};
`;

export const PaymentMethodLogo = styled.img`
  display: block;
  width: auto;
  height: 33px;
`;
